export default __webpack_public_path__ + "static/media/rachel-profile-pic.e72bcf2c.jpg";